/**
 * Configuração global da aplicação
 * Constantes, áreas, feriados e usuários demo
 */

export const APP_CONFIG = {
  VERSION: '2.0.0-react',
  APP_NAME: 'HarmonIA',
  PORTAL_APP_NAME: 'Adjutorem IA',
  
  // Em dev usa proxy do Vite, em produção usa variável de ambiente
  API_BASE: import.meta.env.VITE_API_BASE_URL || '/',
  PORTAL_URL: import.meta.env.VITE_PORTAL_URL || 'https://portal.veiga.law',
  INTERNAL_URL: import.meta.env.VITE_INTERNAL_URL || 'https://gestao.veiga.law',
  TURNSTILE_SITE_KEY: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
  SIGNALR_ENABLED: import.meta.env.VITE_SIGNALR_ENABLED !== 'false',
  AUTH_REFRESH_INTERVAL_MS: Number(import.meta.env.VITE_AUTH_REFRESH_INTERVAL_MS || 1800000),
  AUTH_REFRESH_EARLY_MS: Number(import.meta.env.VITE_AUTH_REFRESH_EARLY_MS || 300000),
  SIGNALR_URL: import.meta.env.VITE_SIGNALR_URL || null,
  SIGNALR_PRAZOS_HUB_PATH: import.meta.env.VITE_SIGNALR_PRAZOS_HUB_PATH || '/hubs/prazos',
  SIGNALR_PRAZOS_EVENT: import.meta.env.VITE_SIGNALR_PRAZOS_EVENT || 'prazosAtualizados',
  SIGNALR_PRAZOS_FALLBACK_TIMEOUT_MS: Number(import.meta.env.VITE_SIGNALR_PRAZOS_FALLBACK_TIMEOUT_MS || 5000),
  
  STORAGE_KEY: 'legalmanager_user',
  DEVICE_ID_STORAGE_KEY: 'legalmanager_device_id',
  ACCESS_TOKEN_EXPIRES_AT_STORAGE_KEY: 'legalmanager_access_token_expires_at',
  ENABLE_DEMO_ACCOUNTS: import.meta.env.DEV || false,
  SESSION_TTL_MINUTES: Number(import.meta.env.VITE_SESSION_TTL_MINUTES || 480),
  ADMIN_ROLE_IDS: String(import.meta.env.VITE_ADMIN_ROLE_IDS || '1,4')
    .split(',')
    .map((value) => Number(value.trim()))
    .filter((value) => Number.isFinite(value)),
  SUPER_ADMIN_ROLE_IDS: String(import.meta.env.VITE_SUPER_ADMIN_ROLE_IDS || '4')
    .split(',')
    .map((value) => Number(value.trim()))
    .filter((value) => Number.isFinite(value)),
  
  AREAS: {
    civel: 'Cível',
    trabalhista: 'Trabalhista',
    criminal: 'Criminal',
    familia: 'Família',
    tributario: 'Tributário',
    administrativo: 'Administrativo',
    consumidor: 'Consumidor',
    outros: 'Outros',
  },

  AREA_COLORS: {
    civel: '#3498db',
    trabalhista: '#e74c3c',
    criminal: '#9b59b6',
    familia: '#f39c12',
    tributario: '#1abc9c',
    administrativo: '#34495e',
    consumidor: '#e67e22',
    outros: '#95a5a6',
  },

  PERIODOS: {
    all: 'Todos os prazos',
    today: 'Hoje',
    week: 'Esta semana',
    month: 'Este mês',
  },

  FERIADOS: [
    '2026-01-01', '2026-02-16', '2026-02-17', '2026-04-03', '2026-04-21',
    '2026-05-01', '2026-05-14', '2026-09-07', '2026-10-12', '2026-10-28',
    '2026-11-02', '2026-11-15', '2026-11-20', '2026-12-25',
  ],
}
